import script from "./PasswordRequirements.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordRequirements.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordRequirements.vue?vue&type=style&index=0&id=799ecb68&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799ecb68"]])

export default __exports__